import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/sphere.svg has a stroke color. Please outline strokes in figma before exporting it to svg.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/sphere.svg
 */
const IconSphere: IconComponent = ({
  size = 24,
  color = '#ffffff',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M7.614 19.599s.837-1.456 2.191-3.8l4.386-7.594 2.195-3.801"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M13.67 20.62a6.504 6.504 0 004.768-5.38 11.364 11.364 0 00-1.675-8.62 6.538 6.538 0 00-6.438-3.237"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M20.298 9.137C19.103 5.7 14.435 4.197 9.836 5.786c-4.598 1.588-7.332 5.648-6.142 9.085M3.557 14.422a10.99 10.99 0 0010.57 6.104"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M3.515 9.707c-.573 2.122 1.778 5.304 5.5 7.462 3.722 2.159 7.661 2.589 9.213 1.034"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M5.768 5.8c-1.206 1.209-.704 3.376 1.281 5.557a16.173 16.173 0 007.983 4.606c2.881.631 5.009-.017 5.453-1.675"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M9.872 3.484c-2.021.5-2.267 2.398-.592 4.55a12.601 12.601 0 007.513 4.338c2.703.374 4.225-.79 3.647-2.792"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M18.726 7.982c.525-.91-.527-2.502-2.351-3.555-1.824-1.054-3.73-1.17-4.255-.258-.526.91.527 2.502 2.35 3.555 1.825 1.054 3.73 1.17 4.256.258z"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
    <path
      d="M19.614 16.396c2.422-4.196.977-9.565-3.228-11.993-4.205-2.428-9.577-.995-12 3.201-2.422 4.196-.977 9.565 3.228 11.993 4.205 2.428 9.577.995 12-3.201z"
      stroke="currentColor"
      strokeWidth={0.24}
      strokeMiterlimit={10}
    />
  </svg>
);

export default IconSphere;
